module.exports = __webpack_public_path__ + "img/77.10880aaa.jpg";